'use strict';

angular.module('mobile-apps')
	.directive('maxStringLengthSelector',['$compile', '$http', '$templateCache', function($compile, $http, $templateCache) {
		return {
			scope:
			{
				base : '=',
				entry : '=',
				isMasterLang : '=',
				role : '='
			},
			templateUrl: 'modules/mobile-apps/views/max-string-length-selector.client.view.html',

			link: function (scope, elem, attrs) {

				// The default options for the select field
				// Option "base" gets only added if it is not master language
				scope.selectOptions = [
					{
						key: 'deactivated',
						text: 'disabled',
						index: 3
					},
					{
						key: 'manual',
						text: 'manually set to',
						index: 2
					}
				];

				// Depending on if it is the master or another option having
				// maxLength not set represents a different value
				var emptyMeaning = {
					'master': 'deactivated',
					'other': 'base'
				};

				var watchInitDataInitialized = false;


				/**
				 * Initialize everything
				 */
				function init() {
					// Set the default value depending on if it is the
					// master-language or not
					if (scope.isMasterLang) {
						scope.maxLengthOptions = emptyMeaning['master'];
					} else {
						scope.maxLengthOptions = emptyMeaning['other'];
					}
					scope.maxLengthValue = 0;

					if (scope.entry.maxLength === -1) {
						scope.maxLengthOptions = 'deactivated';
						scope.maxLengthValue = '';
					} else if (scope.entry.maxLength > 0) {
						scope.maxLengthOptions = 'manual';
						scope.maxLengthValue = scope.entry.maxLength;
					} else {
						if (scope.base && !scope.isMasterLang) {
							scope.maxLengthValue = scope.base.length;
						} else {
							if (scope.maxLengthOptions === 'deactivated') {
								scope.maxLengthValue = '';
							} else {
								scope.maxLengthValue = 0;
							}
						}
					}
				}


				/**
				 * Whenever the dropdown with the max-length-option gets changed
				 * we update the maxLength value on the entry accordingly
				 */
				scope.dropdownChanged = function() {
					var defaultLength = 0;
					if (scope.base) {
						//defaultLength = Math.max(defaultLength, scope.entry.value.length);
						defaultLength = Math.max(defaultLength, scope.base.length);
					}

					if (scope.maxLengthOptions === 'manual') {
						scope.entry.maxLength = defaultLength;
						scope.maxLengthValue = defaultLength;
					} else if (scope.maxLengthOptions === 'deactivated') {
						scope.entry.maxLength = -1;
						scope.maxLengthValue = '';
					} else if (scope.maxLengthOptions === 'base') {
						scope.entry.maxLength = 0;
						scope.maxLengthValue = defaultLength;
					}

				};


				/**
				 * When the input field gets updated does the actual value
				 * on the entry have to get updated
				 */
				scope.maxLengthInputChanged = function() {
					// Should only happen when in "manual" anyway but just check
					// to be sure
					if (scope.maxLengthOptions === 'manual') {
						scope.entry.maxLength = scope.maxLengthValue;
					}
				};


				scope.$watch('isMasterLang', function() {
					// When directive gets loaded the master-language information
					// is not available yet so we keep track of it till we
					// get it to set the available options accordingly.
					var keys = scope.selectOptions.map(function(data) {return data.key});
					var keyIndex = keys.indexOf('base');
					if (scope.isMasterLang) {
						if (keyIndex !== -1) {
							scope.selectOptions.splice(keyIndex, 1);
						}
					} else {
						if (keyIndex === -1) {
							scope.selectOptions.push({
								key: 'base',
								text: 'equals base language',
								index: 1
							});
						}
					}
				});


				scope.$watch('base', function() {
					if (!scope.isMasterLang && scope.maxLengthOptions === 'base' && scope.base) {
						scope.maxLengthValue = scope.base.length;
					}
				});


				scope.$watch('entry.updatedAt', function() {
					// When the directive gets loaded the data is actually not
					// there yet. So we keep track of it till we finally get
					// the data we can do the proper init with
					if (watchInitDataInitialized === false && scope.entry.hasOwnProperty('updatedAt')) {
						// Is a sign that only now we get the correct data so
						// initialize now
						init();
						watchInitDataInitialized = true;
					}
				});


				init();
			}
		};
	}]);
